import React, { useEffect, useMemo } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Card,
  MenuItem,
} from "@mui/material";
import {
  useGetAllLoopingTableQuery,
  useInsertOrUpdateDataLoopingTableMutation,
  useGetProductQuery
} from "../../../Api/attoDeskApi";
import { ILoopingTable } from "../../../Api/Interface/api.interface";
import { useFormik } from "formik";
import CustomSwitch from "../../../Components/Switch/CustomSwitch";
import { useStyles } from "../../../theme/appStyles";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import CloseIcon from "@mui/icons-material/Close";
import { useNotifier } from "../../../Core/Notifier";
import {
  IProductPopUP,
} from "../../../Api/Interface/api.interface";


interface LoopingTableProps {
  productName: string;
  productId: string;
  productDetailsId: string;
  productDetailsIsLooping: boolean;
  productsDetailsLoopingConstant: string;
  loopingTableComplete?: () => void;
  handleLoopingClose?: () => void;
}

const LoopingTable: React.FC<LoopingTableProps> = ({
  productName,
  productId,
  productDetailsId,
  productDetailsIsLooping,
  productsDetailsLoopingConstant,
  loopingTableComplete,
  handleLoopingClose,
}) => {
  const classes = useStyles();
  const { showErrorMessage, showMessage } = useNotifier();
  const [insertDataLoopingTable, { isLoading: loopingDataLoading }] =
    useInsertOrUpdateDataLoopingTableMutation();
  const { data, isLoading, isError, refetch } = useGetAllLoopingTableQuery({
    searchText: "",
    id: productsDetailsLoopingConstant,
  });



    const { data: productData, isLoading: product, isError: productError, refetch: refetchProduct } = useGetProductQuery({
      searchText: "",
      id: String(productDetailsId),
      productBrandId: null,
      productCategoryId: null,
      productTagIds: null,
      productViewOnline: null,
      createdDateStart: null,
      createdDateEnd: null,
      createdDate: null,
    });

        const productDisplay = useMemo(() => {
        if (productData && Array.isArray(productData.data) && productData.data.length > 0) {
          return productData.data[0] as IProductPopUP;
        }
        return null;
      }, [productData]);



  const LoopingTableList = useMemo(() => {
    return data?.data as ILoopingTable[];
  }, [data?.data]);

      



  // Initialize form values based on the columns
  // const initialValues = useMemo(() => {
  //   const values: { [key: string]: any } = {};
  //   LoopingTableList?.[0]?.tableColumns.forEach((column) => {
  //     if (column.type === "boolean") {
  //       values[column.name] = false;
  //     } else if (column.type === "integer") {
  //       values[column.name] = null;
     
  //     } else {
  //       values[column.name] = "";
  //     }
  //   });
  //   return values;
  // }, [LoopingTableList]);

  const initialValues = useMemo(() => {
  const values: { [key: string]: any } = {};

  const productLoopingColumns =
    productDisplay?.loopingDetails?.tableColumns;

  const isEventsTable =
    LoopingTableList?.[0]?.shortTableName === "events";

  const fieldsToPrefill = [
    "onlineSlug",
    "postId",
    "eventStartDate",
    "eventEndDate",
    "bookingStartDate",
    "bookingEndDate",
  ];

  LoopingTableList?.[0]?.tableColumns.forEach((column) => {
    let defaultValue: any = "";

    if (isEventsTable && fieldsToPrefill.includes(column.name)) {
      const productColumn = productLoopingColumns?.find(
        (c: any) => c.name === column.name
      );

      defaultValue = productColumn?.value;
    }

    // Handle types properly
    if (column.type === "boolean") {
      values[column.name] = Boolean(defaultValue);
    } else if (column.type === "integer") {
      values[column.name] =
        defaultValue !== null && defaultValue !== undefined
          ? Number(defaultValue)
          : null;
    } 
    
    else if (column.type === "date") {
        values[column.name] = defaultValue
         ? defaultValue.substring(0, 10)
         : "";
   
    } else {
      values[column.name] =
        defaultValue !== null && defaultValue !== undefined
          ? defaultValue
          : "";
    }
  });

  return values;
}, [LoopingTableList, productDisplay]);

  // Initialize form values based on the columns
// const initialValues = useMemo(() => {
//   const values: { [key: string]: any } = {};
//   LoopingTableList?.[0]?.tableColumns.forEach((column) => {
//     // Set default values for specific fields
//     if (column.name === "onlineSlug") {
//       values[column.name] = "onlineSlug"; // default value
//     } else if (column.name === "postId") {
//       values[column.name] = "12";
//     } else if (column.name === "eventStartDate") {
//       values[column.name] = new Date().toISOString().slice(0, 16); // current date/time in YYYY-MM-DDTHH:MM
//     } else if (column.name === "eventEndDate") {
//       values[column.name] = new Date().toISOString().slice(0, 16);
//     } else if (column.name === "bookingStartDate") {
//       values[column.name] = new Date().toISOString().slice(0, 16);
//     } else if (column.name === "bookingEndDate") {
//       values[column.name] = new Date().toISOString().slice(0, 16);
//     } else if (column.type === "boolean") {
//       values[column.name] = false;
//     } else if (column.type === "integer") {
//       values[column.name] = null;
//     } else {
//       values[column.name] = "";
//     }
//   });
//   return values;
// }, [LoopingTableList]);

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          tableName: LoopingTableList[0]?.shortTableName,
          data: values,
          productId: String(productId),
          type: "variant"
        };

        const addProductResponse = await insertDataLoopingTable(
          temData
        ).unwrap();
        if (!addProductResponse.status) {
          showErrorMessage(addProductResponse.message);
        } else {
          showMessage(addProductResponse.message);
          resetForm();
          if (loopingTableComplete) {
            loopingTableComplete();
          }
        }
      } catch (error) {
        showErrorMessage("Failed to insert data.");
      }
    },
  });

  // function isHTMLSelectElement(
  //   element: EventTarget | null
  // ): element is HTMLSelectElement {
  //   return element instanceof HTMLSelectElement;
  // }

  return (
    <Box>
      {isLoading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="10vh"
        >
          <CircularProgress />
        </Box>
      )}
      {isError && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="10vh"
        >
          <Typography>Error loading data...</Typography>
          <CircularProgress />
        </Box>
      )}

      {LoopingTableList && LoopingTableList.length > 0 && (
        <form onSubmit={formik.handleSubmit}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Looping for {productName}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container spacing={3} p={"24px"}>
                  <Grid item lg={12} md={12} sm={12} xs={12} py={2}>
                    {LoopingTableList[0].tableColumns.map((column) => {
                      switch (column.columnField) {
                        case "TextField":
                          return (
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              sx={{ mt: 2 }}
                            >
                              <Grid item lg={2} md={3} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  {column.name}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={3}
                                md={9}
                                sm={12}
                                xs={12}
                                display="flex"
                                alignItems="center"
                              >
                                <TextField
                                  placeholder={column.name}
                                  size="small"
                                  className={classes.textField}
                                  // {...formik.getFieldProps("categoryName")}
                                  key={column.name}
                                  // label={column.name}
                                  type={
                                    column.type === "integer"
                                      ? "number"
                                      : "text"
                                  }
                                  value={formik.values[column.name]}
                                  onChange={formik.handleChange}
                                  name={column.name}
                                  InputProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: {
                                      fontSize: 14,
                                    },
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        case "Switch":
                          return (
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              sx={{ mt: 2 }}
                            >
                              <Grid item lg={2} md={3} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  {column.name}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={3}
                                md={9}
                                sm={12}
                                xs={12}
                                display="flex"
                                alignItems="center"
                              >
                                <CustomSwitch
                                  color="primary"
                                  sx={{ mr: 2 }}
                                  formik={formik}
                                  name={column.name}
                                  onChange={formik.handleChange}
                                />
                              </Grid>
                            </Grid>
                          );
                        case "Selector":
                          return (
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              spacing={2}
                              sx={{ mt: 2 }}
                            >
                              <Grid item lg={2} md={3} sm={12} xs={12}>
                                <Typography variant="subtitle1">
                                  {column.name}
                                </Typography>
                              </Grid>
                              <Grid
                                item
                                lg={3}
                                md={9}
                                sm={12}
                                xs={12}
                                display="flex"
                                alignItems="center"
                              >
                                <TextField
                                  select
                                  size="small"
                                  key={column.name}
                                  className={classes.textField}
                                  defaultValue=""
                                  InputLabelProps={{ shrink: true }}
                                  value={formik.values[column.name]}
                                  onChange={formik.handleChange}
                                  name={column.name}
                                >
                                  <MenuItem
                                    value=""
                                    disabled
                                    style={{ color: "gray" }}
                                  >
                                    Select an option
                                  </MenuItem>
                                  {(column.options || []).map(
                                    (option: string) => (
                                      <MenuItem key={option} value={option}>
                                        {option}
                                      </MenuItem>
                                    )
                                  )}
                                </TextField>
                              </Grid>
                            </Grid>
                          );
                        // case "MultipleSelector":
                        //   return (
                        //     <Grid
                        //       container
                        //       direction="row"
                        //       alignItems="center"
                        //       spacing={2}
                        //       sx={{ mt: 2 }}
                        //     >
                        //       <Grid item lg={2} md={3} sm={12} xs={12}>
                        //         <Typography
                        //           variant="subtitle1"
                        //           className={classes.typography}
                        //         >
                        //           {column.name}
                        //         </Typography>
                        //       </Grid>
                        //       <Grid
                        //         item
                        //         lg={3}
                        //         md={9}
                        //         sm={12}
                        //         xs={12}
                        //         display="flex"
                        //         alignItems="center"
                        //       >
                        //         <TextField
                        //           select
                        //           size="small"
                        //           sx={{ width: "100%" }}
                        //           SelectProps={{
                        //             multiple: true,
                        //             native: false,
                        //           }}
                        //           InputLabelProps={{ shrink: true }}
                        //           value={formik.values[column.name] || []}
                        //           onChange={(event) => {
                        //             const { target } = event;
                        //             if (isHTMLSelectElement(target)) {
                        //               const selectedValues = Array.from(
                        //                 target.options
                        //               )
                        //                 .filter((option) => option.selected)
                        //                 .map((option) => option.value);
                        //               formik.setFieldValue(
                        //                 column.name,
                        //                 selectedValues
                        //               );
                        //             }
                        //           }}
                        //           name={column.name}
                        //         >
                        //           {!formik.values[column.name]?.length && (
                        //             <MenuItem value="" disabled>
                        //               Select some options
                        //             </MenuItem>
                        //           )}
                        //           {(column.options || []).map(
                        //             (option: string) => (
                        //               <MenuItem key={option} value={option}>
                        //                 {option}
                        //               </MenuItem>
                        //             )
                        //           )}
                        //         </TextField>
                        //       </Grid>
                        //     </Grid>
                        //   );
                       
                        case "DatePicker":
  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{ mt: 2 }}
      key={column.name}
    >
      <Grid item lg={2} md={3} sm={12} xs={12}>
        <Typography variant="subtitle1">
          {column.name}
        </Typography>
      </Grid>
      <Grid
        item
        lg={3}
        md={9}
        sm={12}
        xs={12}
        display="flex"
        alignItems="center"
      >
        <TextField
          type="date"
          size="small"
          className={classes.textField}
          name={column.name}
          value={formik.values[column.name]}
          onChange={formik.handleChange}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
  );

  case "DateTimePicker":
    return (
      <Grid container spacing={2} sx={{ mt: 2 }} key={column.name}>
        <Grid item lg={2} md={3} sm={12} xs={12}>
          <Typography>{column.name}</Typography>
        </Grid>
        <Grid item lg={3} md={9} sm={12} xs={12}>
          <TextField
            type="datetime-local"
            size="small"
            name={column.name}
            value={formik.values[column.name]}
            onChange={formik.handleChange}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>
    );



                        default:
                          return null;
                      }
                    })}
                  </Grid>
                </Grid>

                <Grid container spacing={3} p={"24px"}>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      className={classes.addButton}
                      // onClick={() => formik.resetForm()}
                        onClick={() => {
  formik.resetForm();
  handleLoopingClose?.();   // closes dialog safely
}}
                    >
                      Cancel
                    </Button>
                    <Box m={0.5}></Box>
                    <Button
                      variant="contained"
                      startIcon={<SaveAltIcon />}
                      className={classes.addButton}
                      onClick={() => formik.handleSubmit()}
                      // disabled={!formValid || isLoading || isImageUploading}
                    >
                      Save
                    </Button>
                  </Grid>
                </Grid>
              </Card>
            </Grid>
          </Grid>
        </form>
      )}
    </Box>
  );
};

export default LoopingTable;
